import { render } from "./feature-card.vue?vue&type=template&id=55acdf28&scoped=true&ts=true"
import script from "./feature-card.vue?vue&type=script&lang=ts"
export * from "./feature-card.vue?vue&type=script&lang=ts"

import "./feature-card.vue?vue&type=style&index=0&id=55acdf28&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55acdf28"]])

export default __exports__